var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.939,
    height: 12.449,
    viewBox: "0 0 14.939 12.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase",
    transform: "translate(0 -42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58566",
    "data-name": "Group 58566",
    transform: "translate(0 42.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_58565",
    "data-name": "Group 58565",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11235",
    "data-name": "Path 11235",
    d: "M13.694,44.533H10.582v-.622a1.246,1.246,0,0,0-1.245-1.245H5.6a1.246,1.246,0,0,0-1.245,1.245v.622H1.245A1.246,1.246,0,0,0,0,45.778v1.867a1.246,1.246,0,0,0,1.245,1.245h4.98v-.311a.311.311,0,0,1,.311-.311H8.4a.311.311,0,0,1,.311.311v.311h4.98a1.246,1.246,0,0,0,1.245-1.245V45.778A1.246,1.246,0,0,0,13.694,44.533Zm-4.357,0H5.6v-.622H9.337Z",
    transform: "translate(0 -42.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11236",
    "data-name": "Path 11236",
    d: "M14.766,266.416a.312.312,0,0,0-.326.031,1.229,1.229,0,0,1-.746.256H8.714v.934a.311.311,0,0,1-.311.311H6.536a.311.311,0,0,1-.311-.311V266.7H1.245a1.229,1.229,0,0,1-.746-.256.311.311,0,0,0-.5.248v4.365a1.246,1.246,0,0,0,1.245,1.245H13.694a1.246,1.246,0,0,0,1.245-1.245V266.7A.311.311,0,0,0,14.766,266.416Z",
    transform: "translate(0 -259.856)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.b181d7fa753b381dd88dbc47c63befa9.svg";
export { ForwardRef as ReactComponent };